module.exports = __webpack_public_path__ + "img/logo.4b322d19.jpg";